/**
 * Runtime configuration access.
 *
 * Declares the window.RUNTIME_CONFIG global (injected at deploy time via
 * frontend/public/config/config.js) and exposes getEnv/getStripePublicKey,
 * which validate the injected values and ignore un-substituted "__ENV__"
 * placeholders. The default export snapshots both at module load; getEnv
 * throws if no valid ENV is set. Used by lib/axios.ts and SubmissionDisplay.
 */
import { Environment, Environments } from "@/types/environment";

declare global {
    interface Window {
        RUNTIME_CONFIG?: {
            ENV: string;
            STRIPE_PUBLIC_KEY: string;
        };
    }
}

// Get environment name (prod, dev, etc)
export const getEnv = (): Environment => {
    // In production, use the runtime injected config
    if (window.RUNTIME_CONFIG?.ENV && window.RUNTIME_CONFIG.ENV !== "__ENV__") {
        if (Environments.includes(window.RUNTIME_CONFIG.ENV as Environment)) {
            return window.RUNTIME_CONFIG.ENV as Environment;
        }
        throw new Error(`Invalid environment: ${window.RUNTIME_CONFIG.ENV}`);
    } else {
        throw new Error("No ENV set");
    }
};

// Get Stripe public key
export const getStripePublicKey = (): string | null => {
    if (
        window.RUNTIME_CONFIG?.STRIPE_PUBLIC_KEY &&
        window.RUNTIME_CONFIG.STRIPE_PUBLIC_KEY !== "__STRIPE_PUBLIC_KEY__"
    ) {
        return window.RUNTIME_CONFIG.STRIPE_PUBLIC_KEY;
    }
    return null;
};

// Export configuration object
export default {
    env: getEnv(),
    stripePublicKey: getStripePublicKey(),
};
